import React from 'react'
import PropTypes from 'prop-types'

import RelatedProjectItem from './RelatedProjectItem'

const RelatedProjects = props => {
  if (!props.items || props.items.length === 0) return null

  return (
    <div className="related-projects">
      <h2 className="related-projects-title">Related Projects</h2>

      <ul className="related-projects-list">
        {props.items.map((item, i) => (
          <RelatedProjectItem key={i} item={item} />
        ))}
      </ul>
    </div>
  )
}

RelatedProjects.propTypes = {
  items: PropTypes.array
}

export default RelatedProjects
